import { useEffect } from 'react';
import { metaByLang, languages, fallbackLng, siteUrl } from './seoConfig';

export function Seo({ lang, path = '/' }) {
    useEffect(() => {
        const safeLang = languages.includes(lang) ? lang : fallbackLng;
        const { title, description } = metaByLang[safeLang] ?? metaByLang.en;

        // document.title = title;

        const url = `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`;

        const upsertMetaByName = (name, content) => {
            let el = document.head.querySelector < HTMLMetaElement > (
                `meta[name="${name}"]`
            );
            if (!el) {
                el = document.createElement('meta');
                el.setAttribute('name', name);
                document.head.appendChild(el);
            }
            el.setAttribute('content', content);
        };

        const upsertMetaByProperty = (property, content) => {
            let el = document.head.querySelector < HTMLMetaElement > (
                `meta[property="${property}"]`
            );
            if (!el) {
                el = document.createElement('meta');
                el.setAttribute('property', property);
                document.head.appendChild(el);
            }
            el.setAttribute('content', content);
        };

        // description
        upsertMetaByName('description', description);

        // Open Graph (property)
        upsertMetaByProperty('og:title', title);
        upsertMetaByProperty('og:description', description);
        upsertMetaByProperty('og:type', 'website');
        upsertMetaByProperty('og:url', url);
        upsertMetaByProperty('og:image', `${siteUrl}/screenview.png`);

        // Twitter (name)
        upsertMetaByName('twitter:card', 'summary_large_image');
        upsertMetaByName('twitter:title', title);
        upsertMetaByName('twitter:description', description);
        upsertMetaByName('twitter:image', `${siteUrl}/screenview.png`);
    }, [lang, path]);

    return null;
}
